import React from 'react';
import './style.css';
import Header from '../../components/Header';
import Publication from '../../components/Publication';
import Data from '../../data/Archives.json';


/**
 * @name Archives
 * @constant
 * @function
 * @returns {JSX}
 * @description Display Archives Component
*/
const Archives = () => (
    <section className="container archives">
        <Header title={ Data.PageTitle } />
        <Publication data={ Data } />
    </section>
);



export default Archives;